var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("05 MPPT串列對應")]), _vm._v(" —— "), _c('code', [_vm._v("pv_v")]), _vm._v(" 的每個陣列位置屬於哪一個 MPPT。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("這頁沒有「由遙測產生」")]), _vm._v("。遙測裡根本沒有 MPPT 這一層， "), _c('code', [_vm._v("pv_v[i]")]), _vm._v(" 是一台 INV 的串列攤平成一維，哪幾串共用同一個 MPPT 只有主檔知道 —— 所以這份資料只能人工填，或用 "), _c('code', [_vm._v("docs/kelly/ddl/load_mppt_string_map.js")]), _vm._v(" 從 Excel 匯入。 ")]), _c('li', [_c('strong', [_vm._v("空接的位置也要建一列")]), _vm._v("：MPPT 編號照填，串列編號留空。 留空就是「這個接口沒接東西」，跟「忘了填」分得開。 ")]), _c('li', [_vm._v(" 串列編號格式是 "), _c('code', [_vm._v("INV<INV序號>-<MPPT編號>-<這個 MPPT 裡的第幾格>")]), _vm._v("， 例如 "), _c('code', [_vm._v("INV1-3-1")]), _vm._v("，會依索引自動帶入。第三段"), _c('strong', [_vm._v("連空接也算一格")]), _vm._v("， 所以中間哪一格空接，同一個 MPPT 其他串的編號不會跟著跑 —— 舊的整台連號（"), _c('code', [_vm._v("INV1-STR6")]), _vm._v("）空接一跳後面整排位移，光看編號也認不出是哪一格。 自己改過之後就不再自動蓋。 ")]), _c('li', [_vm._v(" 這個編號就是 "), _c('strong', [_vm._v("02 拓撲階層的 STR 節點編號")]), _vm._v("，兩張表要一致。 02 的「由遙測產生」會來讀這一頁，所以"), _c('strong', [_vm._v("先建這頁、再產 02")]), _vm._v("， 編號才對得起來。 ")]), _c('li', [_vm._v("索引一律 0-based（INV 第一台是 0），MPPT 編號是同一台 INV 內 1-based。")])])]), _c('MasterDataTable', _vm._g({
    attrs: {
      "table": "mppt_string_map",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };